import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment'
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';

@Component({
  selector: 'mark-selections-cancel',
  templateUrl: './mark-selections-cancel.component.html'
})
export class MarkSelectionsCancelModalComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {};

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {}

  @ViewChild('cancelModal', { static: true }) cancelModal: any;
  action: any = {};

  ngOnChanges() {
    if (this.selections && this.selections.selectedSelections && this.selections.selectedSelections.length) {
      this.action = {};
      let d = new Date()
      this.action.dateCanceled = moment(d).format('MMM-DD-YYYY')
      this.cancelModal.show();
    }
  }
  
  cancelSelectionsLoading: boolean = false;
  confirmCancelSelections() {
    const url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/batch-operations/cancel';
    let modelSchema = {
      "dateCanceled": moment(this.action.dateCanceled).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "comments": this.action.comments
    }

    const criteria = {};

    if (this.selections.selection.selectionYear) {
      let selectedYear = new Date(this.selections.selection.selectionYear);
      criteria["selectionYear"] = (selectedYear).getFullYear();
    }

    if (this.selections.selection.region)
      criteria["regionId"] = this.selections.selection.region.id

    if (this.selections.selection.customerDisplayName)
      criteria["customerDisplayName"] = this.selections.selection.customerDisplayName

    if (this.selections.selection.name)
      criteria["name"] = this.selections.selection.name

    if (this.selections.selection.status)
      criteria["status"] = this.selections.selection.status
    criteria["pageNumber"] = this.selections.pageInfo.currentPage;
    criteria["pageSize"] = this.selections.pageInfo.itemsPerPage;
    criteria["isPaging"] = true;
    criteria['applicantComponentSelectionIds'] = this.selections.selectedSelections.map(ss => { return ss })

    modelSchema["criteria"] = criteria;
    modelSchema["selectAll"] = this.selections.selectAllOption.isAllSelected;

    this.cancelSelectionsLoading = true;
    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.cancelSelectionsLoading = false;
    }))
      .subscribe(data => {
        this.cancelModal.hide();
        this.emitSuccess.emit(true)
        this.toastr.success(this.translate.instant('administration_selectionsCanceledSuccessfully_label'), this.translate.instant('administration_success_label'))
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }
}